import { PROJECT_NAME, PROJECT_NAME_ADD, PROJECT_NAME_UPDATE } from '../type'

const initialState = {
  data: null,
  isLoading: false,
  error: null,
}

export function getProjectName(state = initialState, action) {
  switch (action.type) {
    case PROJECT_NAME.REQUEST: {
      return { ...state, isLoading: true, error: null }
    }
    case PROJECT_NAME.FAILURE: {
      return { ...state, isLoading: false, error: action.error }
    }
    case PROJECT_NAME.SUCCESS: {
      return { ...state, isLoading: false, error: null, data: action.payload }
    }
    default:
      return state
  }
}

export function saveProjectName(state = initialState, action) {
  switch (action.type) {
    case PROJECT_NAME_ADD.REQUEST:
      return { ...state, error: null, data: null, isLoading: true }
    case PROJECT_NAME_ADD.SUCCESS:
      return { ...state, error: null, data: action.payload, isLoading: false }
    case PROJECT_NAME_ADD.FAILURE:
      return { ...state, error: action.error, data: null, isLoading: false }
    default:
      return state
  }
}

export function updateProjectName(state = initialState, action) {
  switch (action.type) {
    case PROJECT_NAME_UPDATE.REQUEST:
      return { ...state, error: null, data: null, isLoading: true }
    case PROJECT_NAME_UPDATE.SUCCESS:
      return { ...state, error: null, data: action.payload, isLoading: false }
    case PROJECT_NAME_UPDATE.FAILURE:
      return { ...state, error: action.error, data: null, isLoading: false }
    default:
      return state
  }
}
